/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getMarketingMessage} from '../api'

 export const useQueryGetMarketingMessage = createReactQueryHook('getMarketingMessage', getMarketingMessage)
